import axios from 'axios'
import http from './http'

const baseURL = process.env.VUE_APP_ORIGINACION_URL

const api_token = process.env.VUE_APP_ORIGINACION_TOKEN

export default {
    /**
     * Get all document types.
     * @returns {Promise}
     */
    types() {
        return http.post('typeDocuments')
    },

    /**
     * Upload a document.
     * @param {Object} payload 
     * @returns {Promise}
     */
    upload(payload) {
        const form = new FormData()

        for (var [key, value] of Object.entries(payload)) {
            form.append(key, value)
        }

        form.append('api_token', api_token)

        // Se necesita una instancia de axios que no tenga el interceptor.
        return axios.post(`${baseURL}/file`, form, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }
}